import { NoAdsCompanyIcon } from '@/components/ui/Icons/Icons';
import { Typography } from '@/components/ui/Typography/Typography.styles';

import * as S from '../NoAds.styles';
import { Props } from '../NoAds.types';

export const NoAdsCompany: Props = ({ t, isDark }) => {
  const icon = <NoAdsCompanyIcon isDark={isDark} />;

  return (
    <S.NoAdsWrapper $paddingTop="80px" data-testid="no-ads-company">
      <S.IllustrationWrapper>{icon}</S.IllustrationWrapper>
      <S.TextWrapper>
        <Typography variant="h0">{t('NoAds.company.title')}</Typography>
        <Typography variant="body2">{t('NoAds.company.subtitle')}</Typography>
      </S.TextWrapper>
    </S.NoAdsWrapper>
  );
};
